import React,{useEffect, useState} from 'react';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Spinner from "../../components/spinner/spinner.component";
import CategoriesData from './CategoriesData';
// import {connect} from 'react-redux';
import Header from '../../components/Header';
// import Dropdown from './Dropdown';
import axios from 'axios';
// import ProductsInfo from '../../components/ProductsInfo/ProductsInfo';
import Button from '../../components/controls/Button';
import { categoryArray } from '../../constants/VlplConstants';
import { useDispatch, useSelector } from 'react-redux';
import { setRootCategory } from '../../store/slices/shop/ShopSlice';
import {
  selectRootCategoryIndex,
  selectSubCategoryIndex
} from "../../store/slices/shop/shop.selectors"; 
import { setCategorySelection } from '../../store/slices/shop/ShopSlice';
// import {selectShoppingDataBasedOnGroup} from '../../redux/shop/shop.selectors';
// import {createStructuredSelector} from 'reselect';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  subCategoryContainer: {
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  padding: "10px 12px",
  background: "#fff"
},

chip: {
  padding: "6px 12px",
  borderRadius: 16,
  border: "1px solid #ddd",
  cursor: "pointer",
  fontSize: 13,
  background: "#fafafa",
},

activeChip: {
  background: "#1976d2",
  color: "#fff",
  border: "1px solid #1976d2",
}
}));




export default function ScrollableTabsButtonAuto(props) {
  const classes = useStyles();
  const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

   /** redux */
  const currentUser = useSelector((state) => state.users.currentUser);
  const rootCategoryIndexFromStore = useSelector(selectRootCategoryIndex);
  const subCategoryIndexFromStore = useSelector(selectSubCategoryIndex);
  const dispatch = useDispatch();

  const [spinnerActive, setSpinnerActive] = useState(true);
  const [value, setValue] = useState(subCategoryIndexFromStore);
  const [rootCategoryValue, setRootCategoryValue] = useState(rootCategoryIndexFromStore);
  const [rootCategoryArray, setRootCategoryArray] = useState(categoryArray);
  const [category,setCategory]=useState([]);
  const [filterFn, setFilterFn] =useState({ fn: items => { return items; } });

  useEffect(() => {
    dispatch(setRootCategory(rootCategoryArray[rootCategoryIndexFromStore ?? 0].label));
    getCategory(rootCategoryArray[rootCategoryIndexFromStore ?? 0].label);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);

     dispatch(setCategorySelection({
    rootCategoryIndex: rootCategoryValue,
    subCategoryIndex: newValue
  }));
  };

  const handleChangeRootCategory = (event, newValue) => {
    setRootCategoryValue(newValue);
    setCategory([]);
    let category = rootCategoryArray[newValue];
    dispatch(setRootCategory(category?.label));
    dispatch(setCategorySelection({
    rootCategoryIndex: newValue,
    subCategoryIndex: 0
  }));
    setTimeout(() => {
      if(category?.subCategory?.length) {
        setCategory(category.subCategory);
        setValue(0);
      } else {
        getCategory(category?.label);
      }
    }, 100);
  };
  
  const getCategory = (selectedRootCategory) =>{
      // const brand="BABYHUG";
     const config = {
         headers:{ Authorization: 'Bearer ' + localStorage.getItem('token') }
     }
     axios.get(`getCategory`,(!(props.displayVlplItems || selectedRootCategory === rootCategoryArray[0].label)) && config).then(
         response =>{
           setCategory(response.data);
           setValue(subCategoryIndexFromStore ?? 0);
           let rootCategoryObject = [...rootCategoryArray];
           rootCategoryObject.forEach(obj=> {
            if(obj.label === selectedRootCategory) {
              obj.subCategory = response.data;
            }
           });
           setRootCategoryArray(rootCategoryObject);
           setSpinnerActive(false);
         }
     )
     .catch(error =>{
         setSpinnerActive(false);
     });
     }

     
  return (
  <>
  {!props.displayVlplItems && <Header searchInput={true} setFilterFn={setFilterFn} /> }
  {
    spinnerActive ?
    null
    :
    <div className={classes.root}>
      <AppBar position="static" color="default">
      <Tabs
          value={rootCategoryValue}
          onChange={handleChangeRootCategory}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label={rootCategoryArray[0].label} />
          {
            (currentUser?.roles?.length && !currentUser?.roles?.find(roleObject=> roleObject.name === "User"))  ?
             <Tab label={rootCategoryArray[1].label} /> : ''
          }
        </Tabs>
        {/* <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {
            category!=null? 
              category.map((val, ind) => (
                <Tab key={ind} label={val} />
                    ))
             :null
          }
        
        </Tabs> */}

        {isMobile ? (

  // 📱 MOBILE → Tabs (your current UI)
  <Tabs
    value={value}
    onChange={handleChange}
    indicatorColor="primary"
    textColor="primary"
    variant="scrollable"
    scrollButtons="auto"
  >
    {category?.map((val, ind) => (
      <Tab key={ind} label={val} />
    ))}
  </Tabs>

) : (

  // 💻 DESKTOP → Chips (new UI)
  <div className={classes.subCategoryContainer}>
    {category?.map((val, ind) => (
      <div
        key={ind}
        className={`${classes.chip} ${
          value === ind ? classes.activeChip : ""
        }`}
        onClick={() => {
          setValue(ind);

          dispatch(setCategorySelection({
            rootCategoryIndex: rootCategoryValue,
            subCategoryIndex: ind
          }));
        }}
      >
        {val}
      </div>
    ))}
  </div>

)}
      </AppBar>
      {category.map((val, ind) => (
        value===ind ? <CategoriesData displayVlplItems={props.displayVlplItems || rootCategoryArray[rootCategoryValue]?.label === rootCategoryArray[0].label} infletedRateApply={props.infletedRateApply} index={ind} key={ind} filterFn={filterFn} cat={category[ind]} selectedRootCategory={rootCategoryArray[rootCategoryValue]} /> : null 
       ))
      }
    </div>
  }
    
    
  </>
  );
}



























// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     width: '100%',
//     backgroundColor: theme.palette.background.paper,
//   },
// }));

//  function ScrollableTabsButtonAuto({props,shoppingData}) {
  
//   const classes = useStyles();
//   const [value, setValue] = React.useState(shoppingData);
//   const [data,setData]=useState();
//   // const {infletedRateApply} = props;

  
//   // const[data,setData]=useState([]);
//   const [category,setCategory]=useState([]);
//   const [filterFn, setFilterFn] =useState({ fn: items => { return items; } });
 

//   useEffect(()=>{
// // const filteredList = props.products.shoppingData.filter(prod=> 
// //         value && prod.groupname=="print labels" || 
// //         value && prod.groupname=="heat transfer" );
// //     setValue(filteredList);
//     getCategory();
// },[]);

//   const handleChange = (newValue) => {
//     // setValue(newValue);
//     // console.log(value)
//   // console.log(value);
//   //  const brand="BABYHUG";
//   //  const groupname="paper sticker";
//   //     const config ={
//   //        headers:{ Authorization: 'Bearer ' + localStorage.getItem('token') }
//   //    }
//   //    axios.get(`getproducts/${brand}/${groupname}`,config).then(
//   //        response =>{
//   //          setValue(response.data);
//   //            console.log(response.data);
//   //        }
//   //    )
//   //    .catch(error =>{
//   //        alert("City Is Not Awailable Select None");
//   //    })
     
//   }; 
// const getCategory = () =>{
//   const brand="BABYHUG";
//    const config ={
//      headers:{ Authorization: 'Bearer ' + localStorage.getItem('token') }
//  }
//  axios.get(`getCategory/${brand}`,config).then(
//      response =>{
//        setCategory(response.data);
//          console.log(response.data);
//      }
//  )
//  .catch(error =>{
//      alert("City Is Not Awailable Select None");
//  })
//  }
//   return (
//   <>
  
//   <Header searchInput={true} setFilterFn={setFilterFn} />
 
//     <div className={classes.root}>
//       <AppBar position="static" color="default">
//         <Tabs
//           value={value}
//           onChange={handleChange}
//           indicatorColor="primary"
//           textColor="primary"
//           variant="scrollable"
//           scrollButtons="auto"
//           aria-label="scrollable auto tabs example"
//         >
//           { 
//             category!=null? 
//               category.map((val, ind) => (
               
//                 <Tab key={ind} label={val.grpname}/>
//                     ))
//              :null
//           }
//           {/* <button onClick={clickOnVasants}>VASANTS LABELS</button> */}
//           {/* <Tab label="HOME"/>
//           <Tab label="Item Two"  />
//           <Tab label="Item Three"  />
//           <Tab label="Item Four"  />
//           <Tab label="Item Five"  />
//           <Tab label="Item Six"  />
//           <Tab label="Item Seven"  />
//           <Tab label="Item Four"  />
//           <Tab label="Item Five"  />
//           <Tab label="Item Six"  />
//           <Tab label="Item Seven"  /> */}
//         </Tabs> 
//       </AppBar>
      
//       {category.map((val, ind) => (
//         value===ind ? <CollectionPreview infletedRateApply={props.infletedRateApply} key={ind} filterFn={filterFn}/> : null 
//        ))
//       }

//       {/* {category!=null ? <div>{value===0 ? <CollectionPreview category={Category}/> : null }</div>:null} */}

//       {/* <TabPanel value={value} index={0}>
        
//       </TabPanel>
//       <TabPanel value={value} index={1}>
//       <Navigate
//               to="/login/searchAllProducts"
//       />
//         Item Two
//       </TabPanel>
//       <TabPanel value={value} index={2}>
//         Item Three
//       </TabPanel>
//       <TabPanel value={value} index={3}>
//         Item Four
//       </TabPanel>
//       <TabPanel value={value} index={4}>
//         Item Five
//       </TabPanel>
//       <TabPanel value={value} index={5}>
//         Item Six
//       </TabPanel>
//       <TabPanel value={value} index={6}>
//         Item Seven
//       </TabPanel> */}
//     </div>
    
//   </>
//   );
// }



// export default ScrollableTabsButtonAuto;
